import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import ParticipantsV2Store from '../../Store';
import { COLUMN_COUNT } from '../Columns';

interface Props {
  store: ParticipantsV2Store;
}

const clearQuery = (store: ParticipantsV2Store) => () => store.clearQuery();

function EmptyState({ store }: Props) {
  return (
    <tr>
      <td colSpan={COLUMN_COUNT} className="p-12 text-center">
        <p className="mb-2 text-foreground" style={{ fontWeight: 'var(--font-weight-medium)' }}>
          <T kind="No people match this query" />
        </p>
        <p className="mb-4 text-muted-foreground" style={{ fontSize: 'var(--text-sm)' }}>
          <T kind="Try a different name or email, or clear the query." />
        </p>
        <button
          type="button"
          onClick={clearQuery(store)}
          className="rounded-md border border-border bg-secondary px-4 py-2 text-secondary-foreground transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-ring"
          style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
          data-intercom-target="people-v2-clear-query-button"
        >
          <T kind="Clear query" />
        </button>
      </td>
    </tr>
  );
}

export default observer(EmptyState);
